const courseAccordionSection = document.querySelector('.course-content-section')
if (courseAccordionSection) {
  const courseAccordionCards = courseAccordionSection.querySelectorAll('.accordion-item')
  if (courseAccordionCards) {
    Array.prototype.forEach.call(courseAccordionCards, (card) => {
      const iframeData = card.querySelector('.iframe-data')
      const videoOpen = card.querySelector('.thumbnail-wrapper.has-iframe')
      const popupWrapper = document.querySelector('.course-iframe-wrapper')
      let iframeSrc = ''
      if (iframeData) {
        iframeSrc = iframeData.getAttribute('data-src')
      }
      if (videoOpen) {
        videoOpen.addEventListener('click', () => {
          popupWrapper.innerHTML = ''
          popupWrapper.classList.add('open')
          courseAccordionSection.classList.add('popup-open')
          popupWrapper.innerHTML += iframeData.innerHTML
          popupWrapper.querySelector('iframe').setAttribute('src', iframeSrc)
        })
        popupWrapper.addEventListener('click', (e) => {
          if (e.target !== popupWrapper.querySelector('iframe')) {
            popupWrapper.classList.remove('open')
            popupWrapper.innerHTML = ''
            if (popupWrapper.querySelector('iframe')) {
              popupWrapper.querySelector('iframe').remove()
            }
            courseAccordionSection.classList.remove('popup-open')
          }
        })
      }
    })
  }
}